import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
/* src/app/layout.sidebar/view.scss: no such file or directory */`],
})
export class LayoutSidebarComponent implements OnInit, OnDestroy {
    private readonly sidebarStorageKey = 'hanscribe.sidebar.expanded';
    public mobileSidebarOpen = false;
    public desktopSidebarExpanded = false;
    public clinicFocusMode = false;
    private routerSub: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.mobileSidebarOpen = false;
        this.desktopSidebarExpanded = this.savedDesktopSidebarState();
        this.clinicFocusMode = this.isClinicRoute(this.router.url);
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.mobileSidebarOpen = false;
                this.clinicFocusMode = this.isClinicRoute(event.urlAfterRedirects || event.url);
                await this.service.render();
            }
        });
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public async openMobileSidebar(event?: Event) {
        if (event) event.stopPropagation();
        if (this.clinicFocusMode) return;
        if (this.mobileSidebarOpen) return;
        this.mobileSidebarOpen = true;
        await this.service.render();
        setTimeout(() => document.getElementById('hanscribe-mobile-sidebar-close')?.focus(), 0);
    }

    public async closeMobileSidebar(event?: Event) {
        if (event) event.stopPropagation();
        if (!this.mobileSidebarOpen) return;
        this.mobileSidebarOpen = false;
        await this.service.render();
        setTimeout(() => document.getElementById('hanscribe-mobile-sidebar-open')?.focus(), 0);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    @HostListener('window:hanscribe-sidebar-state', ['$event'])
    public async syncDesktopSidebar(event: any) {
        const expanded = !!(event && event.detail && event.detail.expanded);
        if (this.desktopSidebarExpanded === expanded) return;
        this.desktopSidebarExpanded = expanded;
        await this.service.render();
    }

    @HostListener('document:keydown', ['$event'])
    public async handleDrawerKeyboard(event: KeyboardEvent) {
        if (!this.mobileSidebarOpen) return;
        if (event.key === 'Escape') {
            event.preventDefault();
            await this.closeMobileSidebar();
            return;
        }
        if (event.key !== 'Tab') return;

        const dialog = document.getElementById('hanscribe-mobile-sidebar-dialog');
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((item) => item.offsetParent !== null);
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public desktopSidebarClass() {
        if (this.clinicFocusMode) return 'hidden';
        const width = this.desktopSidebarExpanded ? 'lg:w-56' : 'lg:w-[72px]';
        return `hidden lg:fixed lg:inset-y-0 lg:z-40 lg:flex lg:flex-col lg:overflow-visible lg:transition-[width] lg:duration-200 lg:ease-out ${width}`;
    }

    public contentShellClass() {
        if (this.clinicFocusMode) return 'clinic-focus-shell flex h-full min-w-0 flex-1 flex-col';
        const padding = this.desktopSidebarExpanded ? 'lg:pl-56' : 'lg:pl-[72px]';
        return `flex h-full min-w-0 flex-1 flex-col transition-[padding] duration-200 ease-out ${padding}`;
    }

    private isClinicRoute(url: string = '') {
        let path = String(url || '');
        if (!path && typeof window !== 'undefined') path = window.location.pathname || '';
        path = path.split('?')[0].split('#')[0];
        return /^\/hanscribe\/clinic\/[^/]+\/?$/.test(path);
    }

    private savedDesktopSidebarState() {
        try {
            return localStorage.getItem(this.sidebarStorageKey) === '1';
        } catch (e) {
            return false;
        }
    }
}

export default LayoutSidebarComponent;